<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [dismissableMask]="true"
    [styleClass]="'w-[95vw] h-[100vh] md:w-[500px] md:h-[600px]'" (onHide)="onClose()">

    <div class=" bg-gray-20 border-gray-300">

        <div class="bg-custom-blue w-[calc(100%+3rem)] -ml-6 px-6  pt-1  text-white rounded-t pb-4  sm:px-4">
            <h2 class=" text-2xl font-bold mt-4 font-mulish text-white">Types of Bidding</h2>
            <p class="text-sm mt-2  font-mulish font-semibold  text-white">At auctions, there are two main types of
                bidding. Knowing the difference between them can help you have a better experience and get better
                results when buying items.</p>
        </div>
        <div class="flex flex-col md:flex-row w-full gap-4  ">
            <div class=" flex-1 rounded-lg bg-white shadow-md text-center mt-4 ">
                <div class="flex justify-center mt-2">
                    <span class="text-center font-semibold">Proxy Bidding</span>
                </div>

                <div class="space-y-2 px-2 mt-2">
                    <div class="flex items-start gap-2">
                        <div class="w-10 h-3 bg-custom-blue rounded-sm flex items-center justify-center mt-1">
                            <fa-icon [icon]="faCheck" class="text-white text-[8px] font-bold"></fa-icon>
                        </div>
                        <p class="font-mulish text-sm text-left">
                            Allows you to set a maximum bid, and the system automatically bids for you in small
                            increments
                            up to that amount.
                        </p>
                    </div>

                    <div class="flex items-start gap-2">
                        <div class="w-10 h-3 bg-custom-blue rounded-sm flex items-center justify-center mt-1">
                            <fa-icon [icon]="faCheck" class="text-white text-[8px] font-bold"></fa-icon>
                        </div>
                        <p class="font-mulish text-sm text-left">
                            You can increase your maximum bid anytime before the auction ends, even if you’re already
                            the
                            leading bidder.
                        </p>
                    </div>

                    <div class="flex items-start gap-2 pb-4">
                        <div class="w-4 h-3 bg-custom-blue rounded-sm flex items-center justify-center mt-1">
                            <fa-icon [icon]="faCheck" class="text-white text-[8px] font-bold"></fa-icon>
                        </div>
                        <p class="font-mulish text-sm text-left">
                            You’ll be notified if your maximum bid is outbid.
                        </p>
                    </div>
                </div>
            </div>

            <div class="flex-1 rounded-lg bg-white shadow-md  mt-4 px-2 ">
                <div class="flex justify-center mt-2">
                    <span class="text-center font-semibold">Straight Bidding</span>
                </div>

                <div class="space-y-2 mt-2">
                    <div class="flex items-start gap-2">
                        <div class="w-6 h-3 bg-custom-blue rounded-sm flex items-center justify-center mt-1">
                            <fa-icon [icon]="faCheck" class="text-white text-[8px] font-bold"></fa-icon>
                        </div>
                        <p class="font-mulish text-sm tex-left mb-2">A Straight Bid is placed immediately at the exact
                            amount you
                            specify.</p>
                    </div>

                    <div class="flex items-start gap-2">
                        <div class="w-6 h-3 bg-custom-blue rounded-sm flex items-center justify-center mt-1">
                            <fa-icon [icon]="faCheck" class="text-white text-[8px] font-bold"></fa-icon>
                        </div>
                        <p class="font-mulish text-sm tex-left  mb-2">Your bid becomes the leading bid unless a higher
                            Proxy
                            Bid
                            already
                            exists.</p>
                    </div>

                    <div class="flex items-start gap-2">
                        <div class="w-6 h-3 bg-custom-blue rounded-sm flex items-center justify-center mt-1">
                            <fa-icon [icon]="faCheck" class="text-white text-[8px] font-bold"></fa-icon>
                        </div>

                        <p class="font-mulish text-sm tex-left  mb-2">You'll be notified by email if someone outbids you
                            during the
                            auction.</p>
                    </div>
                </div>
            </div>


        </div>
        <div class="px-4">
            <button pButton
                class=" h-[40px] p-button-info rounded-m w-full relative flex items-center justify-center mt-6 "
                [rounded]="true" (click)="visible = false">

                <fa-icon [icon]="faCheckCircle" class="text-white text-base font-bold p-0 m-0 left-3"></fa-icon>


                <span class="font-semibold text-white text-center w-full text-base">
                    Done
                </span>
            </button>
        </div>
        <div class=" text-center text-base ">
            <a href="https://support.frontstream.com/hc/en-us/articles/115005892426-Types-of-Bidding-Straight-Bidding-vs-Proxy-Bidding-Auction"
                class="text-custom-blue hover:underline font-medium ">
                Learn More
            </a>
        </div>



    </div>

</p-dialog>